import * as React from 'react';
import { connect } from 'react-redux';

import man from 'src/assets/images/man.png'
import 'src/assets/css/Menu_left.css';
import toggle from 'src/assets/images/toggle.svg'
import { withRouter } from "react-router-dom";
import Popup from 'reactjs-popup'
import { ILoginModalProps } from "../loginModal/ILoginModalProps";
import * as actions from "../../actions/userAction";
import { IMenuLeftComponentProps } from "./IMenuLeftComponentProps";
import { IMenuLeftComponentState } from "./IMenuLeftComponentState";
import EditProfileComponent from "../editProfileComponent";

class MenuLeftComponent extends React.Component<IMenuLeftComponentProps, IMenuLeftComponentState> {


    constructor(props: IMenuLeftComponentProps) {
        super(props)

        // Default state
        this.state = {}
    }

    logout() {
        this.props.history.push('/')

        this.props.handleSignOut(() => {
            console.log('Out');

        });
    }
    public render() {
        let divStyle: any;
        if (this.props.currentUser && this.props.currentUser.photo) {
            divStyle = {
                borderRadius: '50%',
                height: 40,
                width: 40
            };

        } else {
            divStyle = {
                borderRadius: '0',
                height: 40,
                width: 40
            };

        }
        const Menu = () => (

            <div className="menu-man">
                <div className="menu_item" onClick={() => { this.props.history.push('/profile') }}> Profil </div>
                <div className="menu_item" onClick={() => { this.props.history.push('/favorites') }}> Favoris </div>
                <EditProfileComponent   />
                <div className="menu_item" onClick={() => this.logout()}> Déconnexion </div>
            </div>
        );

        return (
            <ul className="exo-menu">
                <li className={ !this.props.nodrop ? "drop-down" : null}>
                    <a href='#' style={{
                        display: 'flex',
                        height: '50px',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        width: '230px',
                        cursor: 'pointer'
                    }}>
                        {
                            this.props.currentUser && this.props.currentUser.photo ?
                                <img style={divStyle} src={this.props.currentUser.photo} alt="" /> :
                                <img style={{
                                    borderRadius: '0',
                                    height: 40,
                                    width: 40,
                                    cursor: 'pointer'
                                }} src={man} alt="" />

                        }
                        <i> {this.props.currentUser ?this.props.currentUser.name : null}</i>
                        <img src={toggle} style={{ height: 50, width: 20 }} />
                    </a>
                    <ul style= {{zIndex: 99 }} className={this.props.nodrop ? "animated fadeIn" : "drop-down-ul animated fadeIn"}>
                        <Menu />
                    </ul>
                </li>
            </ul>
        );

    }

}

const mapDispatchToProps = (dispatch: any, ownProps: IMenuLeftComponentProps) => {
    return {
        handleSignOut: (cb) => dispatch(actions.signout(cb))
    }
};

function mapsStateToProps(state) {
    return {
        errorMessage: state.auth.errorMessage,
        // photo: state.auth.currentUser.photo,
        // name: state.auth.currentUser.name,
        currentUser: state.auth.currentUser
    };
}


export default connect(mapsStateToProps, mapDispatchToProps)(withRouter(MenuLeftComponent))



// WEBPACK FOOTER //
// ./src/components/menuLeftComponent/MenuLeftComponent.tsx